module.exports = __webpack_public_path__ + "static/sharon-mccutcheon-tn57JI3CewI-unsplash-f5ba7442cc794d664e9a14ae80658ed9.jpg";